module.exports = __webpack_public_path__ + "static/media/Danthabhagya4.c370834a.jpg";